export class MessageConstants {
	static readonly ConstantDelayForGettingMessages: number = 7000; // تأخیر ثابت بر حسب میلی ثانیه
	static readonly MaxRandomDelayForGettingMessages: number = 20000; // حداکثر تأخیر تصادفی بر حسب میلی ثانیه قبل از گرفتن پیغام‌ها
}

export enum MessageTabs {
	Broker = 1,
	Immediate = 2,
	Portfolio = 3,
	Mofid = 4
}
